import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScheduledMonitorsRepositoryService } from '../../../services/scheduled-monitors/scheduled-monitors-repository.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EnvironmentUrlService } from '../../../services/environment-url/environment-url.service';

@Component({
    selector: 'app-automation-monitors',
    templateUrl: './automation-monitors.component.html',
    styleUrls: ['./automation-monitors.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutomationMonitorsComponent implements OnInit {

  // Separate instance from the scheduled monitors' singleton, so this
  // count-only request doesn't overwrite that table's params.
  private scheduledMonitorService: ScheduledMonitorsRepositoryService;
  protected numFailedMonitors: number = 0;

  private destroyRef = inject(DestroyRef);

  constructor(environmentUrlService: EnvironmentUrlService,
    http: HttpClient,
    messageService: ToastrService) {

    this.scheduledMonitorService = new ScheduledMonitorsRepositoryService(environmentUrlService, http, messageService);
  }

  ngOnInit(): void {
    // The badge only needs the total from the pagination headers. A single
    // record keeps the payload small and counts correctly past 100 failures.
    this.scheduledMonitorService.resourceCount$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(count => this.numFailedMonitors = count);

    this.scheduledMonitorService.getFirstPageSubscribable(new HttpParams()
      .set('pageSize', '1')
      .set('automationType', 'scheduled')
      .set('isFailed', 'true')
    ).subscribe({
      error: () => {
        //Handle Error
      }
    });
  }
}
